export const SEARCH_PAGE_LIMIT = 24;
